<template>
<div id="xinxi" class="xinxi">
	<el-dialog title="修改密码" :visible.sync="dialogFormVisible">
		<el-form :model="ruleForm" :rules="pwdRules" ref="ruleForm">
			<el-form-item label="身份证" prop="idcardInput" :label-width="formLabelWidth">
				<el-input v-model="ruleForm.idcardInput" autocomplete="off" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item label="新密码" prop="pass" :label-width="formLabelWidth">
				<el-input v-model="ruleForm.pass" type="password" autocomplete="off" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="checkPass" :label-width="formLabelWidth">
				<el-input v-model="ruleForm.checkPass" type="password" autocomplete="off" placeholder="暂无填写" @paste.native.capture.prevent="false"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
    		<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
		</div>
	</el-dialog>
    <div class="uinfo">
        <div class="titBox">
            <p class="tit">基本信息</p>
        </div>
		<el-form :model="ruleForm" ref="ruleForm" class="uinfoForm">
			<el-form-item class="lineInput">
				<label class="labelTit">学生姓名</label>
				<el-input disabled v-model="ruleForm.uname" type="text" name="uname" id="uname" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">性别</label>
				<el-input disabled v-model="ruleForm.sex" type="text" name="sex" id="sex" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">出生日期</label>
				<el-input disabled v-model="ruleForm.birthDate" type="text" name="birthDate" id="birthDate" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
                <label class="labelTit">手机号码</label>
				<el-input disabled v-model="ruleForm.uphone" type="text" name="phone" id="phone" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
                <label class="labelTit">最高学历</label>
				<el-input disabled v-model="ruleForm.xueli" type="text" name="xueli" id="xueli" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">校区</label>
				<el-input disabled v-model="ruleForm.area" type="text" name="area" id="area" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">证件类型</label>
				<el-input disabled v-model="ruleForm.idcardType" type="text" name="idcardType" id="idcardType" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">证件号码</label>
				<el-input disabled v-model="ruleForm.idcard" type="text" name="idcard" id="idcard" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">政治面貌</label>
				<el-input disabled v-model="ruleForm.mianmao" type="text" name="mianmao" id="mianmao" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
                <label class="labelTit">民族</label>
				<el-input disabled v-model="ruleForm.minzu" type="text" name="minzu" id="minzu" placeholder="暂无填写"></el-input>
			</el-form-item>
        </el-form>
    </div>
    <div class="xuejiInfo" v-if="hideType === 3">
        <div class="titBox">
            <p class="tit">学籍资料</p>
			<!-- <div class="titRightBox">
				<el-button class="yidong" plain>申请学籍异动</el-button>
			</div> -->
        </div>
		<el-form :model="ruleForm" ref="ruleForm" class="xuejiForm">
			<el-form-item class="lineInput">
				<label class="labelTit">报考学校</label>
				<el-input disabled v-model="ruleForm.school" type="text" name="school" id="school" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">年级</label>
				<el-input disabled v-model="ruleForm.nian" type="text" name="nian" id="nian" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学历层次</label>
				<el-input disabled v-model="ruleForm.cengci" type="text" name="cengci" id="cengci" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">报考专业</label>
				<el-input disabled v-model="ruleForm.zhuanye" type="text" name="zhuanye" id="zhuanye" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">班级</label>
				<el-input disabled v-model="ruleForm.banji" type="text" name="banji" id="banji" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学号</label>
				<el-input disabled v-model="ruleForm.xuehao" type="text" name="xuehao" id="xuehao" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学制</label>
				<el-input disabled v-model="ruleForm.xuezhi" type="text" name="xuezhi" id="xuezhi" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学籍状态</label>
				<el-input disabled v-model="ruleForm.xuejiSt" type="text" name="xuejiSt" id="xuejiSt" placeholder="暂无填写"></el-input>
			</el-form-item>
			<!-- <el-form-item class="lineInput">
				<label class="labelTit">异动审核状态</label>
				<el-input disabled v-model="ruleForm.yidong" type="text" name="yidong" id="yidong" placeholder="暂无填写"></el-input>
			</el-form-item> -->
        </el-form>
    </div>
    <div class="line wx_bind" v-if="wx_name">
		<div class="leftCon">
			<i class="iconfont">&#xe607;</i>
			<h2>微信绑定</h2>
			<span class="wx_name">{{wx_name}}</span>
		</div>
		<div class="rightCon">
			<p class="remove_bind" @click="remove_bind">解除绑定</p>
		</div>
    </div>
	<div @click="open_attestation" class="line pwdChange" v-if="ruleForm.is_certified==1&&temp.attestation">
		<div class="leftCon">
			<i class="iconfont">&#xec4d;</i>
			<h2>实名认证</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
		<span class="text_data" v-if="ruleForm.certified">{{'当前实名'+encryption(ruleForm.idcard)}}</span>
    </div>
    <div @click="dialogFormVisible = true" class="line pwdChange">
		<div class="leftCon">
			<i class="iconfont">&#xe609;</i>
			<h2>修改密码</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
    </div>
    <div @click="jump_purchased" class="line purchased" v-if="temp.purchased">
		<div class="leftCon">
			<i class="iconfont">&#xe677;</i>
			<h2>已购课程</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
    </div>
    <div @click="jump_logs" class="line logs">
		<div class="leftCon">
			<i class="iconfont">&#xe678;</i>
			<h2>操作日志</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
    </div>
</div>
</template>

<script>
function xuejiTxt(ji){
	switch (ji){
		case 1:
			return "在读"
		case 2:
			return "毕业"
		case 3:
			return "停学"
		case 4:
			return "退学"
	}
}
export default {
	name: 'index'
	,props:["userIndex"]
	,data () {
		// var checkAge = (rule, value, callback) => {
		// 	if (!value) {
		// 		return callback(new Error('年龄不能为空'));
		// 	}
		// 	setTimeout(() => {
		// 		if (!Number.isInteger(value)) {
		// 			callback(new Error('请输入数字值'));
		// 		} else {
		// 			if (value < 18) {
		// 				callback(new Error('必须年满18岁'));
		// 			} else {
		// 				callback();
		// 			}
		// 		}
		// 	}, 1000);
		// };
		var validatePass = (rule, value, callback) => {
			// console.log(value);
			let pwdReg = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8}');
			if (value === '' || value === undefined) {
				callback(new Error('请输入密码'));
			} else if (!pwdReg.test(value)) {
				callback(new Error('密码至少包含字母、数字、特殊字符各1位,总长度8位及以上!'));
			} else {
				if (this.ruleForm.checkPass !== '') {
					this.$refs.ruleForm.validateField('checkPass');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			// console.log(value);
			if (value === '' || value === undefined) {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.pass) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
      		temp: this.temp.userCenter.index,
			ruleForm: {
				uname: '',
				uphone: '',
				area: '',
				email: '',
				school: '',
				grade: '',
				cengci: '',
				zhuanye: '',
				idcard:'',
				idcardInput:'',
				pass:'',
				checkPass:'',
				certified:false, //是否已经实名认证
				is_certified:2, //是否开启实名认证
			},
			wx_name:'',
			pwdRules:{
				//required：是否必填，message错误提示内容，trigger触发方式
				idcardInput: [
					{ required: true, message: '请输入身份证号', trigger: 'blur' },
				],
				pass: [
					// { required: true, message: '请输入新密码', trigger: 'blur' },
					{ validator: validatePass, required: true, trigger: 'blur' },
				],
				checkPass: [
					// { required: true, message: '请再次输入密码', trigger: 'blur' },
            		{ validator: validatePass2, required: true, trigger: 'blur' },
				],
			},
			dialogFormVisible: false,
			formLabelWidth: '120px'
		}
	}
	,mounted:function(){
		var that = this
		this.$selfjs.getUserCallFn(this, function(res){
			let idcard = res.idcard,
				idcardType = '身份证'
			that.ruleForm.uname=res.nick_name					//学生姓名
			that.ruleForm.sex=that.$selfjs.getSex(idcard)	//性别
			that.ruleForm.birthDate=that.$selfjs.getBirth(idcard)	//出生日期
			that.ruleForm.uphone=res.mobile						//手机号码
			that.ruleForm.xueli=res.max_education				//最高学历
			that.ruleForm.area=res.student_from					//校区
			that.ruleForm.idcard=idcard						//证件号码
			that.wx_name=res.wx_name						//微信昵称
			that.unionid=res.unionid						//微信unionid
			if(idcard.length <= 15){
				idcardType = '其他'
			}
			that.ruleForm.idcardType = idcardType					//证件类型
			that.ruleForm.mianmao=res.polit_face				//政治面貌
			that.ruleForm.minzu=res.nation						//民族
			// that.ruleForm.email=res.email
			that.ruleForm.school=res.school.school_name			//报考学校
			that.ruleForm.nian=res.grade.grade_name				//年级
			that.ruleForm.cengci=that.$selfjs.type_change(res.major.major_level)	//学历层次
			that.ruleForm.zhuanye=res.major.major_name			//报考专业
			that.ruleForm.banji=res.grade.grade_name			//班级
			that.ruleForm.xuehao=res.student_sn					//学号
			that.ruleForm.xuezhi=res.student_system				//学制
			that.ruleForm.xuejiSt=xuejiTxt(res.student_status)			//学籍状态
			that.ruleForm.yidong=res.yidong || "未申请"	//异动审核状态
			that.ruleForm.certified = res.certified
			that.ruleForm.is_certified = res.school.is_certified
		})
	}
	,methods:{
		// 修改密码
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					var token=this.$cookies.get("token")
						,that=this
					const url = this.global.serverSrc+this.global.qianzui+'/password/reset';
					// return false
					//发送修改密码请求
					this.$ajax.post(url,
						that.$qs.stringify({
							mobile:that.ruleForm.idcardInput
							,password:that.ruleForm.pass
						})
					)
					.then(function(res){
						let resData=res.data;
						if(resData.code==0){
							//弹出即将退出登录的提示框
							that.$alert('修改密码成功，点击确定退出登录状态！！！', '信息提示', {
								confirmButtonText: '确定',
								callback: action => {
									that.$selfjs.loginOUtFn(that, "location")
								}
							});
							that.$message.close();
						}else{
							that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 已购课程跳转
		jump_purchased(){
			this.$emit('jump',['/web/purchased/', 'purchased'])
		},
		// 操作日志跳转
		jump_logs(){
			this.$emit('jump',['/web/logs', 'logs'])
		},
		//实名认证跳转
		open_attestation(){
			// if (!this.ruleForm.certified) {
				this.$emit('jump',['/web/name_attestation/', 'name_attestation'])
			// }
		},
		//微信解绑
		remove_bind(){
			let that = this
			const loading = this.$loading({
          		lock: true,
          		text: 'Loading',
          		spinner: 'el-icon-loading',
          		background: 'rgba(0, 0, 0, 0.7)'
        	});
			this.$ajax.post(
				this.global.serverSrc+this.global.qianzui+'/login/wechat_unbundling'
				,this.$qs.stringify({
					unionid:this.unionid
				})
			)
			.then(function (res){
				let resData=res.data;
				if(resData.code==0){
					that.$message({
						message: '微信解绑成功',
						type: 'success'
					});
					that.unionid = ''
					that.wx_name = ''
				}else{
					that.$message.error(resData.message)
				}
				loading.close();
			}).catch(function (res){
				that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
		},
		//身份证脱敏
		encryption(text){
			if (text) {
				return text.replace(/(.{3}).*(.{3})/,"$1******$2")
			}
			
		},
	}
	,computed:{
		//根据身份隐藏内容
		hideType(){
			return parseInt(this.$store.state.hideType)
		},
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/userCenter/index.vue